import { useState, useContext } from "react";
import { toast } from "sonner";
import axios from "axios";
import { SiteContext } from "@/App";
import { Loader2, Eye, EyeOff, Lock } from "lucide-react";

export default function LoginView({ onLogin }) {
  const { API } = useContext(SiteContext);
  const [creds, setCreds] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, creds);
      onLogin(data.token);
      toast.success("Welcome, Admin.");
    } catch {
      toast.error("Invalid credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleLogin} className="space-y-6 py-4">
      <div className="text-center mb-6">
        <Lock size={32} className="text-verde mx-auto mb-3" />
        <p className="font-manrope text-[#525252] text-sm">Admin access only</p>
      </div>
      <div>
        <label className="font-manrope text-[10px] tracking-widest uppercase text-[#525252] block mb-2">Username</label>
        <input
          data-testid="admin-username"
          value={creds.username}
          onChange={e => setCreds(p => ({ ...p, username: e.target.value }))}
          className="w-full bg-ink-800 border border-ink-600 focus:border-verde text-[#E5E5E5] font-manrope text-sm px-4 py-3 rounded-sm outline-none transition-colors"
        />
      </div>
      <div>
        <label className="font-manrope text-[10px] tracking-widest uppercase text-[#525252] block mb-2">Password</label>
        <div className="relative">
          <input
            data-testid="admin-password"
            type={showPass ? "text" : "password"}
            value={creds.password}
            onChange={e => setCreds(p => ({ ...p, password: e.target.value }))}
            className="w-full bg-ink-800 border border-ink-600 focus:border-verde text-[#E5E5E5] font-manrope text-sm px-4 py-3 pr-12 rounded-sm outline-none transition-colors"
          />
          <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-3 top-3 text-[#525252] hover:text-[#E5E5E5]">
            {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
      </div>
      <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full btn-verde py-3 disabled:opacity-60">
        {loading ? <Loader2 size={16} className="animate-spin mx-auto" /> : "Sign In"}
      </button>
    </form>
  );
}
